import { Dialog, DialogContent } from '@mui/material';
import React,{useState} from 'react'
import attendanceServices from '../attendanceServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';

function LeaveRequestStatus({leaveRequest,callBack}) {
    const [dialogStatus,setDialogStatus] = useState(false);
    const {AppAlert} = useAlert();
    const {employeeDD,getDDDataById} = useAppData()
    
    const [saving,setSavingStatus] = useState(false);

    const updateStatus = (status) =>{
        setSavingStatus(true);
        let payload={
            id :leaveRequest.id,
            status:status
        }

        attendanceServices.updateLeaveRequest(payload).then(res=>{
            callBack();
            AppAlert(res.msg);
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
            setDialogStatus(false);
        })
    }

    return (
        <>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                maxWidth="sm"
            >
                <DialogContent>
                    <h5>Change Leave Request Status</h5>
                    <button onClick={()=>updateStatus(1)}  className='me-3 btn btn-outline-warning'>Requested</button>
                    <button onClick={()=>updateStatus(2)}  className='me-3 btn btn-outline-success'>Approve</button>
                    <button onClick={()=>updateStatus(3)}  className='me-3 btn btn-outline-danger'>Reject</button>
                </DialogContent>
            </Dialog>
            
                {leaveRequest.status == 1 && <button className='btn btn-warning' onClick={()=>setDialogStatus(true)} >Requested</button>}
                {leaveRequest.status == 2 && <button className='btn btn-success' onClick={()=>setDialogStatus(true)} >Approved</button>}
                {leaveRequest.status == 3 && <button className='btn btn-danger' onClick={()=>setDialogStatus(true)} >Rejected</button>}

                {leaveRequest.updatedBy != null && 
                    <div>
                        <span className='fw-bold'>Updated By :</span> {getDDDataById(employeeDD,leaveRequest.updatedBy).label}
                    </div>
                }
            
        </>
    )
}

export default LeaveRequestStatus